import React,{useEffect,useState} from 'react'
import {Box,Typography,Button,Grid,Paper, CircularProgress, IconButton, Menu, Select, MenuItem, FormControl, InputLabel} from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../Components/Header'
import {useTheme,styled } from '@mui/material/styles'
import {useSelector, useDispatch} from 'react-redux';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import axios from 'axios'
import { AddCardOutlined, ArrowBack, ArrowDropDownCircleOutlined, BackHand, BookOnline, Edit, ScoreOutlined, SettingsAccessibility } from '@mui/icons-material';
import {Snackbar} from '@mui/material';
import ContentView from '../Components/ContentView';
import UserInput from "../Components/UserInput"
import CollapsibleTable from '../Components/CollapsibleTable';
import JobParticipants from '../Components/JobParticipants';
import UnmatchedDialog from '../Components/UnmatchedDialog';
import CandidateDialog from '../Components/CandidateDialog';
import MatchDialog from '../Components/MatchDialog';
import { add_candidates, delete_candidates } from '../Redux/settingSlice';
import { add_job, add_jobs } from '../Redux/jobSlice';

const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black",
	margin:20
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownCircleOutlined sx={{ fontSize: 30 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	height:100,
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
		marginBottom: theme.spacing(1),
	}
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	background:theme.palette.mode === 'dark'? 'black' : 'white',
}));

const  JobReport = ()=>{
    
const test = useSelector(state => state?.test.test);
const data = useSelector(state => state?.job.job);
const jobs = useSelector(state => state?.job.jobs);
const user = useSelector(state => state?.auth.user);
const candidates = useSelector(state => state?.setting.candidates);
const [submitting,setSubmitting] = useState(false)
const [loading,setLoading] = useState(false)
const navigate = useNavigate()
const [expanded, setExpanded] = useState(false);
const [open,setOpen] = useState(false)
const [showAccepted,setShowAccepted] = useState(false)
const [showUnmatched,setShowUnmatched] = useState(false)
const [message,setMessage] = useState('')
const dispatch = useDispatch()
const [newData,setNewData] = useState(data || [])
const [change,setChange] = useState(false)
const [matching,setMatching] = useState(false)
const [fetching,setFetching] = useState(false)
const [anchorEl, setAnchorEl] = useState(null);
const [mobileAnchorEl, setMobileAnchorEl] = useState(null);
const [filterData,setFilterData] = useState("pending")
const [accepting,setAccepting] = useState(false)

const isMenuOpen = Boolean(anchorEl);
const isApiMenuOpen = Boolean(mobileAnchorEl);

const menuId = 'primary-search-account-menu';
const mobileMenuId = 'primary-search-account-menu-mobile';

const handleMobileMenuClose = () => {
setMobileAnchorEl(null);
};

const handleMenuClose = () => {
setAnchorEl(null);
handleMobileMenuClose();
};

const handleMenuOpen = (event) => {
setAnchorEl(event?.currentTarget);
};
const handleChange = () => (event, newExpanded) => {
	setExpanded(newExpanded ? true : false);
};

const handleSnackbarClose = ()=>{
	setOpen(false)
}

useEffect(()=>{
	(
		async ()=>{
			var app = []
			await dispatch(delete_candidates())

			const users = newData?.applicants?.filter(item=>item?.status === "accepted") || []

			for (let i = 0; i < users?.length; i++) {
				
				const applicant = {
					first_name:users[i]?.user?.first_name,
					last_name:users[i]?.user?.last_name,
					email:users[i]?.email,
					hasTook:false,
					hasFinished:false,
					warning:null,
					isDisqualified:false,
					data:[]
				}

				app.push(applicant)
				
			}
			await dispatch(add_candidates(app))
		}
	)()
	},[data])

useEffect(()=>{
if (data?.owner !== user?.email) {
	navigate("/dashboard")
}
},[])

const renderMenu = (
<Menu
	anchorEl={anchorEl}
	anchorOrigin={{
	vertical: 'top',
	horizontal: 'right',
	}}
	id={menuId}
	keepMounted
	transformOrigin={{
	vertical: 'top',
	horizontal: 'right',
	}}
	open={isMenuOpen}
	onClose={handleMenuClose}
>
	<MenuItem sx={{width:250,height:40}} 
		onClick={async (e)=>{
			e?.preventDefault()
			navigate("/myTests")
			handleMenuClose()
		}}>
			<IconButton
				size="large"
				aria-label="account of current user"
				aria-controls="primary-search-account-menu"
				aria-haspopup="true"
				color="inherit"
				>
				<BackHand sx={{color:"yellow"}} fontSize="small"/>
			</IconButton>
			<p style={{marginLeft:10,fontSize:12}}>Make an assessment</p>
		</MenuItem>
	</Menu>
);

const handleMachAll = async ()=>{
    try {

		setMatching(true)

		const send_data = {
			email:user?.email,
			id:data?.id,
			filt:filterData
		}

		const sendMatch = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/user/match-all/`,send_data,{
			headers:{
				"Content-Type":"application/json",
				"Authorization":`Bear ${user?.accessToken}`
			}
		}).catch(err=>{
			setMatching(false)
			setMessage("please,check your connection and try again")
			setOpen(true)
		})

		if (sendMatch?.status == 200 && sendMatch?.data?.success) {
			
			setMessage(sendMatch?.data?.message)
			setOpen(true)

			const newJobData = {
				...data,
				applicants:sendMatch?.data?.applicants
			}

			setNewData(newJobData)

			const filterData = jobs?.filter(item=>item?.id !== data?.id) || []

			await dispatch(add_job(newJobData))
			await dispatch(add_jobs([...filterData,newJobData]))

			var accCandidates = []
			const arr = sendMatch?.data?.applicants?.filter(itm=>itm.status === "accepted")

			for (let i = 0; i < arr.length; i++) {
				accCandidates.push({
					first_name:arr[i].user.first_name,
					last_name:arr[i].user.last_name,
					email:arr[i].email,
					hasTook:false,
					hasFinished:false,
					warning:null,
					isDisqualified:false,
					data:[]
				})
			}
			await dispatch(add_candidates(accCandidates))
		}
		setMatching(false)
    } catch (error) {
        console.log(error)
    }
}

const handleAcceptAll = async ()=>{
    try {
		if (filterData !== "accepted") {
			setAccepting(true)

			const send_data = {
				email:user?.email,
				id:data?.id,
				filt:filterData
			}
	
			const sendAccept = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/user/select-all/`,send_data,{
				headers:{
					"Content-Type":"application/json",
					"Authorization":`Bear ${user?.accessToken}`
				}
			}).catch(err=>{
				setAccepting(false)
				setMessage("error...check your connection and try again")
				setOpen(true)
			})
	
			if (sendAccept?.status == 200 && sendAccept?.data?.success) {
				
				setMessage(sendAccept?.data?.message)
				setOpen(true)
	
				const newJobData = {
					...data,
					applicants:sendAccept?.data?.applicants
				}
	
				setNewData(newJobData)
	
				const filterData = jobs?.filter(item=>item?.id !== data?.id) || []
	
				await dispatch(add_job(newJobData))
				await dispatch(add_jobs([...filterData,newJobData]))
	
				var accCandidates = []
				const arr = sendAccept?.data?.applicants?.filter(itm=>itm.status === "accepted")
	
				for (let i = 0; i < arr.length; i++) {
					accCandidates.push({
						first_name:arr[i].user.first_name,
						last_name:arr[i].user.last_name,
						email:arr[i].email,
						hasTook:false,
						hasFinished:false,
						warning:null,
						isDisqualified:false,
						data:[]
					})
				}
				await dispatch(add_candidates(accCandidates))
			}
			setAccepting(false)
		} else {
			setMessage("you have first to switch to other status than accepted status")
			setOpen(true)
		}
    } catch (error) {
        console.log(error)
    }
}

const handleFetchAll = async ()=>{
    try {
		setFetching(true)

		const send_data = {
			email:user?.email,
			id:data?.id,
			filt:filterData
		}

		const handleFetch = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/user/applicants-all/`,send_data,{
			headers:{
				"Content-Type":"application/json",
				"Authorization":`Bear ${user?.accessToken}`
			}
		}).catch(err=>{
			setFetching(false)
			setMessage("error...check your connection and try again")
			setOpen(true)
		})

		if (handleFetch?.status == 200 && handleFetch?.data?.success) {

			const newJobData = {
				...data,
				applicants:handleFetch?.data?.applicants
			}

			setNewData(newJobData)

			const filterData = jobs?.filter(item=>item?.id !== data?.id) || []

			dispatch(add_job(newJobData))
			dispatch(add_jobs([...filterData,newJobData]))

			var accCandidates = []
			const arr = handleFetch?.data?.applicants?.filter(itm=>itm.status === "accepted")

			for (let i = 0; i < arr.length; i++) {
				accCandidates.push({
					first_name:arr[i].user.first_name,
					last_name:arr[i].user.last_name,
					email:arr[i].email,
					hasTook:false,
					hasFinished:false,
					warning:null,
					isDisqualified:false,
					data:[]
				})
			}
			await dispatch(add_candidates(accCandidates))
		}else{
			setMessage(handleFetch?.data?.message)
			setOpen(true)
		}
		setFetching(false)
    } catch (error) {
        console.log(error)
    }
}

useEffect(()=>{
	handleFetchAll()
},[filterData])

return(
	<Box style={{width:"100%",height:"100%"}}>
		<Header>
			<Breadcrumbs aria-label="breadcrumb">
				<Typography sx={{fontSize:12,color:"gray"}}> Dashboard </Typography>
				<Typography sx={{fontSize:12,color:"gray"}}>Job report</Typography>
			</Breadcrumbs>			
		</Header>
		<Snackbar 
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}} 
			message={message} 
			onClose={handleSnackbarClose} 
			open={open} 
			autoHideDuration={2000}
		/>
		<Box display="flex" flexWrap="wrap" flexDirection="row" justifyContent="space-between" alignItems="center" sx={{width:"95%",marginLeft:2}}>
			<Box display="flex" flexWrap="wrap" flexDirection="row" width="30%" justifyContent="flex-start" alignItems="center">
				<IconButton onClick={(e)=>{
					e?.preventDefault()
					navigate("/jobInfo")
				}}>
					<ArrowBack sx={{color:"gold"}} fontSize='small'/>
				</IconButton>
				<Button  onClick={(e)=>{
					e?.preventDefault()
					setShowUnmatched(true)
				}} sx={{background:"maroon",color:"white",margin:1,fontFamily:"dinofans",fontSize:12}} variant="outlined">
					View unmatched
				</Button>				
			</Box>
			<Box  display="flex" flexWrap="wrap" flexDirection="row" justifyContent="flex-end" alignItems="center">
				<Button  onClick={async (e)=>{
					e?.preventDefault()
					await handleAcceptAll()
				}} disabled={accepting} sx={{background:"#fff",color:"#000",margin:1,fontFamily:"dinofans",fontSize:12,width:120}} variant="outlined">
					{
						accepting ? <CircularProgress sx={{color:"#000"}} size={15}/> : "Accept all"
					}
				</Button>
				<Button  onClick={async (e)=>{
					e?.preventDefault()
					await handleMachAll()
				}} disabled={matching} sx={{background:"maroon",color:"white",margin:1,fontFamily:"dinofans",fontSize:12,width:120}} variant="outlined">
					{
						matching ? <CircularProgress sx={{color:"#fff"}} size={15}/> : "Match all"
					}
				</Button>
				<Button  onClick={(e)=>{
					e?.preventDefault()
					setShowAccepted(true)
				}} sx={{background:"maroon",color:"white",margin:1,fontFamily:"dinofans",fontSize:12}} variant="outlined">
					View accepted
				</Button>
				<IconButton onClick={handleMenuOpen}>
					<BookOnline sx={{color:"#fff"}} fontSize='small'/>
				</IconButton>
				<IconButton>
					<SettingsAccessibility sx={{color:"#fff"}} fontSize='small'/>
				</IconButton>
			</Box>
		</Box>
		{renderMenu}
		<Box ml={2}>
			<Typography sx={{color:"white",padding:1,fontSize:14}}>
				{newData?.applicants?.filter(item=>item?.status === filterData && item?.hasFinished)?.length > 0 ? newData?.applicants?.filter(item=>item?.status === filterData && item?.hasFinished)?.length : 0} Total candidate(s)
			</Typography>
		</Box>
		<Box ml={2} justifyContent="flex-start" alignItems="flex-start" width="30%" mt={1} >
			<FormControl fullWidth>
				<InputLabel style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gold"}} id="filter-label">Status</InputLabel>
				<Select
					labelId="filter-label"
					value={filterData}
					label="Status"
					sx={{height:45,fontSize:14}}
					onChange={(e)=>{
						setFilterData(e.target.value)
					}}
				>
					<MenuItem sx={{fontSize:13}} value="pending">pending</MenuItem>
					<MenuItem sx={{fontSize:13}} value="accepted">accepted</MenuItem>
					<MenuItem sx={{fontSize:13}} value="rejected">rejected</MenuItem>
				</Select>
			</FormControl>
			{
				fetching && (
					<CircularProgress sx={{color:"#ff0",mt:2}} size={20}/>
				)
			}
		</Box>
		<JobParticipants filterData={filterData}/>
		<Box height={20}>
		</Box>
		<CandidateDialog data={newData?.applicants?.filter(item=>item?.status === "accepted")} visible={showAccepted} setVisible={setShowAccepted}/>
		<UnmatchedDialog data={newData?.unmatched} visible={showUnmatched} setVisible={setShowUnmatched}/>
	</Box>
    )
}

export default JobReport